import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';
import PageHeader from './PageHeader';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';

export default class NotificationScreen extends React.PureComponent {
    static propTypes = {
        headerText: translationPropType.isRequired,
        iconType: ICON_TYPE_PROP_TYPE.isRequired,
        subtitleText: translationPropType,
        iconColor: PropTypes.string,
    };

    render() {
        const { headerText, iconColor, iconType, subtitleText } = this.props;

        const gridClasses = classNames(
            'eds-g-cell',
            'container-max-width',
            'eds-g-cell--has-overflow',
        );

        return (
            <div className="eds-g-group eds-align--center">
                <div className={gridClasses}>
                    <PageHeader
                        headerText={headerText}
                        iconType={iconType}
                        subtitleText={subtitleText}
                        iconColor={iconColor}
                    />
                </div>
            </div>
        );
    }
}
